'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _botSessions = require('./bot-sessions.html');

var _botSessions2 = _interopRequireDefault(_botSessions);

var _botSessions3 = require('./bot-sessions.controller');

var _botSessions4 = _interopRequireDefault(_botSessions3);

require('./bot-sessions.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var botSessionsComponent = {
  restrict: 'E',
  bindings: {},
  template: _botSessions2.default,
  controller: _botSessions4.default,
  controllerAs: 'vm'
};

exports.default = botSessionsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/bot-sessions/bot-sessions.component.js
 **/